"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLazyRef;

var _react = require("react");

var UNINITIALIZED = Symbol();

function useLazyRef(refInit) {
  var ref = (0, _react.useRef)(UNINITIALIZED);

  if (ref.current === UNINITIALIZED) {
    ref.current = refInit();
  }

  return ref;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJVTklOSVRJQUxJWkVEIiwiU3ltYm9sIiwidXNlTGF6eVJlZiIsInJlZkluaXQiLCJyZWYiLCJ1c2VSZWYiLCJjdXJyZW50Il0sInNvdXJjZVJvb3QiOiJidW5kbGU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYWRhcHRpdmVDYXJkcy9BdHRhY2htZW50L0FkYXB0aXZlQ2FyZEhhY2tzL3ByaXZhdGUvdXNlTGF6eVJlZi50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VSZWYgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB0eXBlIHsgTXV0YWJsZVJlZk9iamVjdCB9IGZyb20gJ3JlYWN0JztcblxuY29uc3QgVU5JTklUSUFMSVpFRCA9IFN5bWJvbCgpO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VMYXp5UmVmPFQ+KHJlZkluaXQ6ICgpID0+IFQpOiBNdXRhYmxlUmVmT2JqZWN0PFQ+IHtcbiAgY29uc3QgcmVmID0gdXNlUmVmPFQgfCB0eXBlb2YgVU5JTklUSUFMSVpFRD4oVU5JTklUSUFMSVpFRCk7XG5cbiAgaWYgKHJlZi5jdXJyZW50ID09PSBVTklOSVRJQUxJWkVEKSB7XG4gICAgcmVmLmN1cnJlbnQgPSByZWZJbml0KCk7XG4gIH1cblxuICByZXR1cm4gcmVmIGFzIE11dGFibGVSZWZPYmplY3Q8VD47XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFJQSxJQUFNQSxhQUFhLEdBQUdDLE1BQU0sRUFBNUI7O0FBRWUsU0FBU0MsVUFBVCxDQUF1QkMsT0FBdkIsRUFBOEQ7RUFDM0UsSUFBTUMsR0FBRyxHQUFHLElBQUFDLGFBQUEsRUFBaUNMLGFBQWpDLENBQVo7O0VBRUEsSUFBSUksR0FBRyxDQUFDRSxPQUFKLEtBQWdCTixhQUFwQixFQUFtQztJQUNqQ0ksR0FBRyxDQUFDRSxPQUFKLEdBQWNILE9BQU8sRUFBckI7RUFDRDs7RUFFRCxPQUFPQyxHQUFQO0FBQ0QifQ==